import React, { useEffect, useState, useRef } from 'react';
import Select, { components, MultiValueRemoveProps } from 'react-select';
import variables_style from "../../assets/variables.json";
import  "../../assets/stylesheets/sass/Dropdownlist.module.scss";
import makeAnimated from 'react-select/animated';
import close_icon_black from "../../assets/icons/close_icon_black.svg";
import localforage from 'localforage';
import { useSelector } from 'react-redux';
import { ReactSession }  from 'react-client-session';
 
export default function Dropdownlist({isClearable, language, data, placeholder, onChange, menuPlacement, isSearchable, defaultValue, type, width, theme, id, valueForm, enableMultipleItems, value, valueInArray, clear}){
    const doctypeTranslations = useSelector(state => state.doctypesTranslations)

    const customStyles = {
      menu: (provided, state) => ({
        ...provided,
        backgroundColor: "white",
        marginTop: "0rem",
        border: "1px solid gainsboro",
        boxShadow:"none",
        borderRadius: "0px",
        transition:"0.1s ease all",
        zIndex:"900",
        width: width === "small" ? "fit-content" : "100%",
      }),
      option: (provided, state) => ({
        ...provided,
        cursor: "pointer",
        padding:".6rem 1.2rem",
        backgroundColor: state.isSelected ? variables_style.colors.color_primary : "white",

        "&:hover": {
            color: "white",
            backgroundColor: variables_style.colors.color_primary,
        }
      }),
      dropdownIndicator: (provided, state) => ({
        ...provided,
        "&:hover": {
            color: variables_style.colors.color_primary,
        }
      }),
      control: (provided, state)=>({
        ...provided,
        border: type === "language" ? 0 : theme !== "inputfield" ? "1px solid gainsboro" : "none",  
        borderBottom: theme === "inputfield" ? ((state.isActive || state.isFocused) ? `2px solid ${variables_style.colors.color_primary}` : "1px solid gainsboro") : "1px solid gainsboro",
        borderRadius: theme === "inputfield" && "0",
        boxShadow: type === "language" && 'none',

        "&:hover": {
          borderBottom: theme === "inputfield" ? ((state.isActive || state.isFocused) ? `2px solid ${variables_style.colors.color_primary}` : "1px solid gainsboro") : "1px solid gainsboro",
        }
      }),
      valueContainer: (provided, state)=>({
        ...provided,
        paddingLeft: theme === "inputfield" && "0"
      }),
      multiValueRemove: (base) => ({
        ...base,
        cursor:"pointer"
      }),
      menuPortal: base => ({ ...base, zIndex: 9999 })
    }

    const [selectedOption, setselectedOption] = useState(null);
    const [options, setoptions] = useState([]);
    const [DefVal, setDefVal] = useState(false);

    const setValueDropdown = (selectedOption) =>{
      if(!selectedOption){onChange(""); return;}
      let v = selectedOption.value
      if(type === "language" && v === "D"){onChange("N")}
      else if(type === "language" && v === "A"){onChange("E")}
      else{
        onChange(v);
      }
    }

    const handleChange = (selectedOption) => {
        setselectedOption(selectedOption);
        if(!enableMultipleItems){
          setValueDropdown(selectedOption)
        }
        else {
          if(type === "language" && selectedOption === "D"){onChange("N")}
          else if(type === "language" && selectedOption === "A"){onChange("E")}
          else{
            onChange(selectedOption)
          }
        }
    };

    const capitalizeFirstLetter = (string) =>{
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    useEffect(()=>{
      //SET VALUE AND LABEL OF DROPDOWNLIST ITEMS
      if(type === "ID_NAME" && data){
        let tmp = [];
        for (let i = 0; i < data.length; i++) {   
          let item = data[i];
          if(typeof(item) === "string" && item !== "undefined_undefined"){
            let item_splitted = item.split("_");
            tmp.push({value: item_splitted[0], label: item_splitted[1]})

            setoptions(tmp);
          }
        }

        if(defaultValue && !DefVal){
          if(typeof(defaultValue) === "string"){
            tmp.forEach((item, index)=>{
              if(item.label.toLowerCase() === defaultValue.toLowerCase() || item.value.toString() === defaultValue.toString()){
                setselectedOption(tmp[index])
              }
            })
          }

          else if(typeof(defaultValue) === "object"){
            let new_df = []

            for (let i = 0; i < defaultValue.length; i++) {
              tmp.forEach(item => {
                if((item.label.toString().replace(/ /g,'').toLowerCase() === defaultValue[i].toString().replace(/ /g,'').toLowerCase()) || (item.value.toString().toLowerCase() === defaultValue[i].toString().split(" ").join("").toLowerCase())){
                  new_df.push(item);
                }
              });
            }
            setselectedOption(new_df);
          }
          
          else{ 
            setselectedOption(tmp[0])
          }
          setDefVal(true)
        }
        return;
      }

      if(type === "SAP" && data){
        let tmp = [];
        for (let i = 0; i < data.length; i++) {   
          let item = data[i];
          if(typeof(item) === "string" && item !== "undefined_undefined"){
            let item_splitted = item.split("_");
            tmp.push({value: item_splitted[0], label: item_splitted[1]+" - "+item_splitted[0]})

            setoptions(tmp);
          }
        }

        if(defaultValue && !DefVal){
          console.log(tmp)
          setDefVal(true)
          setselectedOption(tmp[0])
        }
      }

      else if(type === "language"){
        let tmp = [];
        for (let i = 0; i < data.length; i++) {   
          let item = data[i];
          if(typeof(item) === "string"){
            let letter = item.charAt(0)
            tmp.push({value: letter, label: item})
            setoptions(tmp);
          }
        }
      }

      else if(data){
        let tmp = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];    
            if(valueForm === "twoletters"){
              tmp.push({value: item.substring(0,2).toUpperCase(), label: capitalizeFirstLetter(item)})
            }    
            else if(valueForm === "all"){
              tmp.push({value: item.substring(0,600).toUpperCase(), label: capitalizeFirstLetter(item)})
            }  
            else{
              tmp.push({value: item.charAt(0), label: capitalizeFirstLetter(item)})
            }
            
            setoptions(tmp);
        }

        if(defaultValue && !DefVal){
          setDefVal(true)
          setselectedOption(tmp[0])
        }
      }   
      
      if(type === "DOCTYPE" && data){
        const getData = async () =>{
          let doctypes = await localforage.getItem("docTypes")
          if(doctypes){
            let tmp = [];
            for (let i = 0; i < data.length; i++) {
              for (let j = 0; j < doctypes.length; j++) {
                if(data[i] === doctypes[j].doctype){
                  tmp.push({value: data[i], label: doctypeTranslations[doctypes[j].doctype][ReactSession.get("language")]})
                }
              }         
            }
            
            setoptions(tmp);
          }
         
        }
        getData();
      }
    }, [data])

    useEffect(()=>{
      if(language) {
        if(type === "DOCTYPE" && data){
          const getData = async () =>{
            let doctypes = await localforage.getItem("docTypes")
            if(doctypes){
              let tmp = [];
              for (let i = 0; i < data.length; i++) {
                for (let j = 0; j < doctypes.length; j++) {
                  if(data[i] === doctypes[j].doctype){
                    tmp.push({value: data[i], label: doctypeTranslations[doctypes[j].doctype][ReactSession.get("language")]})
                  }
                }         
              }
              
              setoptions(tmp);
            }
           
          }
          getData();
        }
      }
    }, [language])
    
    useEffect(()=>{
      if(clear){
        setselectedOption(null)
      }  
    }, [clear])

    const animatedComponents = makeAnimated();

    const MultiValueRemove = (props) => {
      return (
          <components.MultiValueRemove {...props}>
            <img src={close_icon_black} alt="icon"/>
          </components.MultiValueRemove>
      );
    };
    
  return (
      <>
        {theme === "inputfield" && <p style={{color: "#9b9b9b", fontSize:"12px", marginTop:"15px"}}>{placeholder}</p>}
        <Select
        isClearable={isClearable}
        noOptionsMessage={() => 'Geen opties gevonden'}
        menuPortalTarget={document.body} 
        components={{MultiValueRemove}} 
        closeMenuOnSelect={!enableMultipleItems} 
        isMulti={enableMultipleItems} 
        inputId={id} 
        isSearchable={isSearchable !== null ? isSearchable : (type === "language" ? false : true)} 
        menuPlacement={menuPlacement} 
        placeholder={placeholder} 
        styles={customStyles} 
        value={value ? 
          (type !== "language" ? options.filter(option =>  option.label === value) : options.filter(option =>  option.value === value))
          : 
          valueInArray ? 
            valueInArray 
            : 
            (clear ? null : selectedOption) 
        } 
        onChange={handleChange} 
        options={options} 
        theme={(theme) => ({ ...theme, borderRadius: ".2rem", colors: {...theme.colors, primary25: '#0084ff', primary: '#0084ff', primary50: '#0084ff' }})}/>
      </>
  )
}